"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookShareButton = void 0;
var FacebookShareButton_1 = require("./FacebookShareButton");
Object.defineProperty(exports, "FacebookShareButton", { enumerable: true, get: function () { return FacebookShareButton_1.FacebookShareButton; } });
